import { Modal } from "antd";

/**
 * 🎨 Popup Utility - פתיחת חלונות קופצים
 * 
 * @param {Object} options - אפשרויות המודל
 * @param {string} options.title - כותרת המודל
 * @param {React.ReactNode} options.content - תוכן המודל
 * @param {number} options.width - רוחב המודל (default: 600)
 * @param {boolean} options.footer - האם להציג footer (default: null)
 * @param {boolean} options.destroyOnClose - האם להרוס בסגירה (default: true)
 * @returns {Function} - פונקציה שמחזירה handler לפתיחת המודל
 */
export const createPopup = () => {
    return ({ title, content, width = 600, footer = null, destroyOnClose = true }) => {
        return () => {
            Modal.info({
                title,
                content,
                width,
                footer,
                destroyOnClose,
                icon: null,
                maskClosable: true,
                okText: "סגור",
            });
        };
    };
};

/**
 * 🎨 Popup Hook - פונקציה להצגת modal
 */
export const popup = ({ title, content, width = 600, footer = null, destroyOnClose = true, onOk, onCancel }) => {
    return () => {
        const modal = Modal.info({
            title,
            content,
            width,
            footer,
            destroyOnClose,
            icon: null,
            maskClosable: true,
            okText: "סגור",
            onOk,
            onCancel,
            closable: true,
        });

        return modal;
    };
};
